import React, { useState } from 'react';
import { Modal, Toast } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import TextareaAutosize from "react-textarea-autosize";

const AddModuloModal = ({
	showModalAddModulo,
	setShowModalAddModulo,
	setShowModalAddAula,
	setReloadData,
	reloadData,
	moduloAddFile,
	setModuloAddFile,
	register_M,
	errors_M,
	control_M,
	handleSubmit_M,
	onSubmitAddModulo,
	handleKeyPress
}) => {
	const [toast, setToast] = useState({});
	const [showToast, setShowToast] = useState(false);

	const handleClose = () => {
		setShowModalAddModulo(false);
		setShowModalAddAula(true);
		setReloadData(!reloadData);
	};

	// Função para mostrar mensagens de toast
	const showToastMessage = (header, body, variant = 'light') => {
		setToast({ header, body, variant });
		setShowToast(true);
	};
	
	// Função para submeter o formulário com feedback de toast
	const handleSubmitWithToast = async (data) => {
		try {
			const result = await onSubmitAddModulo(data);

			if (result && result.success) {
				showToastMessage('Sucesso!', result.message || 'Módulo adicionado com sucesso.', 'success');
				setTimeout(() => {
					handleClose();
				}, 2000);
			} else if (result) {
				showToastMessage('Erro!', result.message || 'Erro ao adicionar módulo.', 'danger');
			}
		} catch (error) {
			showToastMessage('Erro!', error.message || 'Ocorreu um erro inesperado.', 'danger');
		}
	};

	return (
		<>
			<Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
				<Toast.Header>
					<strong className="mr-auto">{toast.header}</strong>
				</Toast.Header>
				<Toast.Body>{toast.body}</Toast.Body>
			</Toast>

		<Modal
			size="lg"
			show={showModalAddModulo}
			onHide={handleClose}
		>
			<Modal.Header closeButton>
				<span className="fw-semibold fs-4 text-primary">Adicionar Módulo</span>
			</Modal.Header>
			<Modal.Body>
					<form onSubmit={handleSubmit_M(handleSubmitWithToast)}>
					<div className="row">
						<div className="col-md-12">
							<div className="body">
								<div className="d-flex mb-5">
									<div className="d-flex flex-column w-100">
										<div className="row mb-3">
											<div className="col-12">
												<div className="mb-3">
													<label className="form-label text-primary fw-medium">Curso</label>
													<input
														readOnly
														placeholder="Escolha um curso"
														className='form-control border-primary'
														{...register_M('cursos_nome', { required: true })}
													/>
													<input
														type='hidden'
														{...register_M('idCurso', { required: true })}
													/>
												</div>
											</div>
										</div>
										<div className="row mb-3">
											<div className="col-12 col-md-12">
												<div className="mb-3">
													<label className="form-label text-primary fw-medium">Titulo</label>
													<input
														type="text"
														{...register_M('nome', { required: true })}
														placeholder="Título do Módulo"
														className="form-control border-primary"
													/>
													{errors_M.nome && <span className='text-danger fs-7'>Título do módulo é obrigatório.</span>}
												</div>
											</div>
										</div>
										<div className="row mb-3">
											<div className="col-12 col-md-6">
												<div className="mb-3">
													<label className="form-label text-primary fw-medium">Thumbnail</label>
													<label
														htmlFor="thumbnail"
														className={`form-control label-input-simple ${moduloAddFile ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center`}
													>
														<i className="bi bi-card-image me-2"></i>Enviar Arquivo
													</label>
													<Controller
														control={control_M}
														name="thumbnail"
														rules={{ required: true }}
														render={({ field: { onChange, onBlur, value, ref } }) => (
															<input
																id='thumbnail'
																type="file"
																onBlur={onBlur}
																ref={ref}
																onChange={(e) => {
																	const files = e.target.files;
																	onChange(files);
																	if (files && files.length > 0) {
																		setModuloAddFile(true);
																	} else {
																		setModuloAddFile(false);
																	}
																}}
															/>
														)}
													/>
													{errors_M.thumbnail && <span className='text-danger fs-7'>Imagem do módulo é obrigatório.</span>}
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="mb-3">
													<label className="form-label text-primary fw-medium">Carga Horária <span className="text-dark">(em horas)</span></label>
													<input
														type="text"
														maxLength="6"
														onKeyDown={handleKeyPress}
														{...register_M('carga_horaria')}
														placeholder="120:00"
														className="form-control border-primary"
													/>
												</div>
											</div>
										</div>
										<div className="row mb-3">
											<div className="col-12 col-md-12">
												<div className="mb-3">
													<label className="form-label text-primary fw-medium">Resumo</label>
													<TextareaAutosize
														{...register_M('resumo', { required: true })}
														placeholder="Resumo"
														className="form-control border-primary"
													/>
													{errors_M.resumo && <span className='text-danger fs-7'>Resumo é obrigatório.</span>}
												</div>
											</div>
										</div>
										<div className="row mb-3">
											<div className="col-12">
												<div className="mb-3">
													<label className="form-label text-primary fw-medium">Descrição</label>
													<TextareaAutosize
														{...register_M('descricao')}
														placeholder="Descrição sobre o módulo"
														className="form-control border-primary"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="d-flex justify-content-center mb-4">
						<button type="submit" className="btn btn-primary text-white px-5 py-2">Salvar</button>
						<button
							type="button"
							className="btn btn-outline-primary text-primary px-5 py-2 ms-4"
							onClick={handleClose}
						>
							Cancelar
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
		</>
	);
};

export default AddModuloModal; 